import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, switchMap } from 'rxjs';

import { RouterService } from '@services/router.service';
import { DocumentService } from '@services/api/document/document.service';
import { UserDataService } from '@services/data/user-data.service';

export const DocDetailGuard: CanActivateFn = (route) => {
    const documentService = inject(DocumentService);
    const routerService = inject(RouterService);
    const userDataService = inject(UserDataService);

    const documentId = Number(route.params['id']);

    return documentService.canEditDocument(documentId).pipe(
        switchMap((canEdit) => {
            if (canEdit) {
                return of(true);
            }

            const currentUserId = userDataService.currentUser?.id;

            if (!currentUserId) {
                routerService.goApp();
                return of(false);
            }

            return documentService.getCollaborators(documentId).pipe(
                map(({ collaborators }) =>
                    collaborators.some(
                        (collaborator) => collaborator.id === currentUserId,
                    ),
                ),
                map((isCollaborator) => {
                    if (isCollaborator) {
                        return true;
                    }

                    routerService.goApp();
                    return false;
                }),
                catchError(() => {
                    routerService.goApp();
                    return of(false);
                }),
            );
        }),
    );
};
